var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C11.4477 3 11 3.44772 11 4V12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12V4C13 3.44772 12.5523 3 12 3ZM8.70698 7.29289C9.09751 7.68342 9.09751 8.31658 8.70698 8.70711L4.70698 12.7071C4.31646 13.0976 3.6833 13.0976 3.29277 12.7071C2.90225 12.3166 2.90225 11.6834 3.29277 11.2929L6.58566 8L3.29277 4.70711C2.90225 4.31658 2.90225 3.68342 3.29277 3.29289C3.6833 2.90237 4.31646 2.90237 4.70698 3.29289L8.70698 7.29289Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLast);
export default __webpack_public_path__ + "static/media/Chevron-Last.00ee09728502007e555257d9e1f875dd.svg";
export { ForwardRef as ReactComponent };